import React from 'react';
import PropTypes from 'prop-types';


function FilterTableHeader({ changeText, advancedSearchLink, getDowloadExcel }) {
  return (
    <div className="live_search">
      <span>Find What: </span>
      <input onChange={changeText}
             placeholder="enter search term"
             type="search"
             style={{ width: 250 }} />
      { advancedSearchLink }
      { getDowloadExcel }
    </div>
  );
}

FilterTableHeader.defaultProps = {
  advancedSearchLink: null,
  getDowloadExcel: null,
  changeText: () => null,
};

FilterTableHeader.propTypes = {
  advancedSearchLink: PropTypes.any,
  getDowloadExcel: PropTypes.any,
  changeText: PropTypes.func,
};

export default FilterTableHeader;



// WEBPACK FOOTER //
// ./src/components/common/FilterTableHeader.js